export const PUBLIC_ROUTES = ['/login'];

export const NAV_LINKS = [
	{
		label: 'Dashboard',
		href: '/dashboard'
	},
	{
		label: 'Projects',
		href: '/projects'
	},
	{
		label: 'Sprints',
		href: '/sprints'
	},
	{
		label: 'Tasks',
		href: '/tasks'
	},
	{
		label: 'Teams',
		href: '/teams'
	}
];
